export default {"src":"/_next/static/media/arrowForward.3f1628e4.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};